import { Injectable } from '@angular/core';

export interface ApiErrorEntry {
    form: string;
    status: number;
    body: string;
}

/**
 * Última petición AES fallida, para enseñar a soporte el response real: el
 * DataInterceptor convierte los errores de negocio en un código numérico y el
 * XML original no llega a quien captura el error
 */
@Injectable({ providedIn: 'root' })
export class ApiErrorLogService {
    last: ApiErrorEntry | null = null;

    record(form: string, status: number, body: unknown): void {
        this.last = { form, status, body: typeof body === 'string' ? body : '' };
    }

    clear(): void {
        this.last = null;
    }
}
